import { Heart } from "lucide-react";
import React, { useState } from "react";
import {
  addToWishlist,
  fetchWishlist,
  removeFromWishlist,
} from "../../Redux/WishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import Image from "../Image";
import { ProtectedFunction } from "../ProtectRoutes";
import { api } from "../../api/api";
import { Wish } from "../../api/urls";
// import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import Loading from "../Loading";
// import {Loading } from "../../components/Loading"

export const ProductWithActionCard = ({ product }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const wishlist = useSelector((state) => state.wishlist);
  const [isWishlisted, setIsWishlisted] = useState(
    product && wishlist?.some((item) => item?.product === product?.id)
  );
  const wishID =
    product && wishlist?.find((item) => item?.product === product?.id)?.id;

  // const handleEvent = async () => {
  //   // e.stopPropagation(); //  Prevent card navigation
  //     setIsLoading(true);
  //   if (isWishlisted) {
  //     await api.delete(Wish + `${wishID}/`);
  //     dispatch(removeFromWishlist(wishID));
  //     setIsWishlisted(false);
  //   } else {
  //     const res = await api.post(Wish, { product: product.id });
  //     dispatch(addToWishlist(res?.data));
  //     setIsWishlisted(true);
  //   }
  //   dispatch(fetchWishlist());
  // };
  const handleEvent = async () => {
    // e.preventDefault();
    // e.stopPropagation();

    // setIsLoading(true);
    if (isLoading) return; //  Prevent double-click
    setIsLoading(true);
    try {
      if (isWishlisted) {
        await api.delete(Wish + `${wishID}/`);
        dispatch(removeFromWishlist(wishID));
        setIsWishlisted(false);
      } else {
        const res = await api.post(Wish, { product: product.id });
        dispatch(addToWishlist(res?.data));
        setIsWishlisted(true);
      }

      dispatch(fetchWishlist());
    } finally {
      // setIsLoading(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* {isLoading && <Loading />} */}

      <div
        className="product-card"
        onClick={() => navigate(`/products/${product.id}`)}
        style={{ cursor: "pointer" }}
      >
        <div className="product-image-wrapper">
          {product.inventory?.[0]?.images?.[0]?.img ? (
            <Image
              src={product.inventory[0].images[0].img}
              alt={product.title}
              className="product-image"
            />
          ) : (
            <p className="no-image">Image not available</p>
          )}

          {/* <ProtectedFunction onClick={handleEvent}>
         
          <button className="wishlist-btn" disabled={isLoading}>
  <Heart
    size={20}
    fill={isWishlisted ? "#fa192f" : "none"}
    color={isWishlisted ? "#fa192f" : "#444"}
  />
</button>

        </ProtectedFunction> */}
          <ProtectedFunction onClick={handleEvent}>
            <button className="wishlist-btn" disabled={isLoading}>
              <Heart
                size={20}
                fill={isWishlisted ? "#fa192f" : "none"}
                color={isWishlisted ? "#fa192f" : "#444"}
              />
            </button>
          </ProtectedFunction>
        </div>

        <div className="product-info">
          <span className="product-status">FEW ITEMS LEFT</span>
          <h3 className="product-title">{product.title}</h3>
          <span>
            ₹ {product.inventory[0]?.size_and_price[0]?.product_price}
          </span>
          <span className="product-tax">MRP incl. of all taxes</span>
        </div>
      </div>
    </>
  );
};

// export const ProductWithPricingCard = ({ product, data, image }) => {
//   const navigate = useNavigate();
//   return (
//     <div
//       onClick={() => navigate(`/products/${product.id}`)}
//       style={{ cursor: "pointer", textAlign: "center" }}
//       className="custom-card"
//     >
//       <Image
//         src={image}
//         style={{
//           width: "213px",
//           height: "300px",
//           objectFit: "cover",
//           borderRadius: "5px",
//           marginBottom: "10px",
//         }}
//         className="custom-card-img"
//       />
//       <div className="card_text">
//         <p>FEW ITEMS LEFT</p>
//         <h3>{data?.title}</h3>
//         <h4>₹ {data?.inventory[0]?.size_and_price[0]?.product_price}</h4>
//         <p>MRP incl. of all taxes</p>
//       </div>
//     </div>
//   );
// };

export const ProductCard = ({ product, data, image, isYouMayLike }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(`/products/${product.id}`)}
      style={{
        boxSizing: "border-box",
        textAlign: "center",
        width: "100%",
        maxWidth: "300px",
        // margin: "auto",
        // padding: "12px",
        objectFit: "cover",
        cursor: "pointer",
      }}
      className="border rounded-lg"
    >
      <Image
        src={image}
        className="custom-card-img"

        style={{
          width: "100%",
          height: "auto",
          // maxHeight: "250px",
          aspectRatio: "2/3",
          objectFit: "cover",
          borderRadius: "8px",
          // marginBottom: "10px",
        }}
      />
      {!isYouMayLike && (
        <div className="card_text">
          {/* <p
            style={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#666",
              margin: 0,
            }}
          >
            FEW ITEMS LEFT
          </p> */}
          <h3
            style={{
              fontSize: "15px",
              margin: "6px 0",
              fontWeight: 500,
            }}
          >
            {product?.title}
          </h3>
          <h4
            style={{
              fontSize: "16px",
              margin: "4px 0",
              fontWeight: 600,
            }}
          >
            ₹ {product?.inventory?.[0]?.size_and_price?.[0]?.product_price}
          </h4>
          <p
            style={{
              fontSize: "12px",
              color: "#666",
              margin: 0,
            }}
          >
            MRP incl. of all taxes
          </p>
        </div>
      )}
    </div>
  );
};
